export default "__VITE_ASSET__DbR9m$Gu__"